import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { App } from '@df/core/app';
import { TradeStoreService } from '../multisite/trade/trade-store.service';
import { EpsilonService } from './epsilon.service';

@NgModule({
    imports: [CommonModule],
    providers: [EpsilonService]
})
export class EpsilonModule {
    constructor(
        private epsilonService: EpsilonService,
        private app: App,
        private tradestoreService: TradeStoreService
    ) {
        if (this.app.isPlatformBrowser && !this.tradestoreService.isTradeStore()) {
            this.epsilonService.setupTracking();
        }
    }
}
